export default {
    statuses: state => state.statuses
}